module.exports = __webpack_public_path__ + "static/media/guldentech.53e867a6.png";